<template>
  <v-container fluid class="pa-15">
    <v-row>
      <v-col
        cols="12"
        sm="4"
        md="3"
        lg="2"
        class="pa-2"
        v-for="movie in popularMovies"
        :key="movie.id"
      >
        <movie-card :movie="movie" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MovieCard from "../components/MovieCard.vue";
export default {
  components: {
    MovieCard,
  },
  data() {
    return {
      popularMovies: [],
      type: null,
      id: null,
    };
  },
  mounted() {
    this.getMovies();
  },
  methods: {
    async getMovies() {
      const response = await this.$http.get("/movie/popular");
      this.popularMovies = response.data.results.slice(0, 12);
    },
  },
};
</script>
